var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.orgs,"label":"Organisations","item-text":"name","loading":_vm.loading > 0,"disabled":_vm.disabled,"outlined":"","return-object":""},on:{"change":_vm.orgChanged},model:{value:(_vm.selectedOrg),callback:function ($$v) {_vm.selectedOrg=$$v},expression:"selectedOrg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }